<header class="pt-[20px] bg-white pb-[20px]">
  <form action="" class="border bg-[var(--lightBlue)] rounded-xl p-3 w-[95%] mx-auto">
    <span class="font-bold text-[#4D748D] text-[25px]">Filtros</span>

    <ul id="btns_filter" class="flex gap-4 cursor-pointer pt-5 pb-5 flex-wrap">
  <li class="text-[#4D748D] font-bold">Exibir:</li>
  <li [class.font-bold]="filters.answerStatus === 'all'" 
      [class.text-[#4D748D]]="filters.answerStatus === 'all'"
      (click)="filters.answerStatus = 'all'; applyFilters()">
    Todas as questões
  </li>
  <li [class.font-bold]="filters.answerStatus === 'answered'" 
      [class.text-[#4D748D]]="filters.answerStatus === 'answered'"
      (click)="filters.answerStatus = 'answered'; applyFilters()">
    Questões resolvidas
  </li>
  <li [class.font-bold]="filters.answerStatus === 'not_answered'" 
      [class.text-[#4D748D]]="filters.answerStatus === 'not_answered'"
      (click)="filters.answerStatus = 'not_answered'; applyFilters()">
    Questões não resolvidas
  </li>
  <li [class.font-bold]="filters.answerStatus === 'correct'" 
      [class.text-[#4D748D]]="filters.answerStatus === 'correct'"
      (click)="filters.answerStatus = 'correct'; applyFilters()">
    Questões que acertei
  </li>
  <li [class.font-bold]="filters.answerStatus === 'incorrect'" 
      [class.text-[#4D748D]]="filters.answerStatus === 'incorrect'"
      (click)="filters.answerStatus = 'incorrect'; applyFilters()">
    Questões que errei
  </li>
</ul>

    <ul id="select_filter" class="flex pb-5 pr-8 flex-wrap gap-5">
      <li>
        <select [(ngModel)]="filters.questionType" name="questionType" (change)="applyFilters()">
          <option value="">Tipo da questão</option>
          <option value="mult">Múltipla escolha</option>
          <option value="tf">Verdadeiro ou Falso</option>
        </select>
      </li>
      <li>
        <select [(ngModel)]="filters.difficulty" name="difficulty" (change)="applyFilters()">
          <option value="">Nível de dificuldade</option>
          <option value="Fácil">Fácil</option>
          <option value="Médio">Médio</option>
          <option value="Difícil">Difícil</option>
        </select>
      </li>
      <li>
        <select [(ngModel)]="filters.positions" name="positions" (change)="applyFilters()">
          <option value="">Cargo</option>
          <option *ngFor="let position of filterOptions.positions" [value]="position.id">{{ position.name }}</option>
        </select>

      </li>
      <li>
        <select [(ngModel)]="filters.bancas" name="bancas" (change)="applyFilters()">
          <option value="">Bancas Examinadora</option>
          <option *ngFor="let banca of filterOptions.bancas" [value]="banca.id">{{ banca.name }}</option>
        </select>
      </li>
      <li>
        <select [(ngModel)]="filters.subjects" name="subjects" (change)="applyFilters()">
          <option value="">Disciplina</option>
          <option *ngFor="let subject of filterOptions.subjects" [value]="subject.id">{{ subject.name }}</option>
        </select>
      </li>
      <li>
        <select [(ngModel)]="filters.topics" name="topics" (change)="applyFilters()">
          <option value="">Assuntos</option>
          <option *ngFor="let topic of filterOptions.topics" [value]="topic.id">{{ topic.name }}</option>
        </select>
      </li>
      <li>
        <select [(ngModel)]="filters.year" name="year" (change)="applyFilters()">
          <option value="">Ano</option>
          <option *ngFor="let year of years" [value]="year">{{ year }}</option>
        </select>
      </li>
    </ul>

    <div class="flex gap-2">
      <button class="flex text-left bg-[var(--lightRed)] text-white p-2 mt-5 w-fit rounded-xl items-center gap-2"
        (click)="applyFilters()">
        <i class='bx bx-search'></i>
        Filtrar
      </button>
      <button class="flex text-left bg-[var(--lightRed)] text-white p-2 mt-5 w-fit rounded-xl items-center gap-2"
        onclick="window.location.reload()">
        <i class='bx bx-eraser'></i>
        Limpar
      </button>
    </div>
    <div *ngIf="filterText" class="mt-5 text-gray-600 text-lg italic absolute">
      <strong>Filtro:</strong> {{ filterText }}
    </div>
  </form>
</header>



<main *ngIf="isPlanChecked" id="questions_container" class="flex flex-col py-5 bg-white">
  <div *ngIf="!hasAccess"
    class="text-center text-[--lightRedText] font-bold mt-10 mb-10 flex flex-col items-center justify-center"
    style="height: 50vh;">
    <i class='bx bxs-lock text-[60px] text-[#D62828]'></i>
    <p class="text-[20px] text-[#4D748D] mt-4">Este conteúdo é exclusivo para assinantes.</p>
    <button class="bg-[#D62828] hover:bg-[#b31f1f] text-white font-bold py-2 px-6 rounded-full text-sm mt-4"
      [routerLink]="['/my-space/my-plan']">
      Assinar agora
    </button>
  </div>
  <div *ngIf="isLoading && hasAccess" class="flex justify-center items-center flex-col gap-5 h-[50vh]">
    <div
      class="spinner animate-spin rounded-full border-4 border-t-4 border-[--lightRed] border-solid w-16 h-16 border-t-transparent shadow-lg">
    </div>
    <span class="text-[--lightRed]">Carregando...</span>
  </div>

  <div *ngIf="!isLoading && hasAccess">
    <ng-container *ngIf="questions.length > 0; else noQuestions">
      <app-question *ngFor="let question of questions" [question]="question"></app-question>

      <div class="flex justify-center items-center my-10">
        <nav class="flex items-center space-x-2">
          <!-- Botão de página anterior -->
          <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
            class="px-4 py-2 rounded-lg bg-[var(--lightRed)] text-white disabled:bg-gray-300 disabled:cursor-not-allowed">
            Anterior
          </button>

          <!-- Indicador de página atual -->
          <span class="px-4 py-2 text-[var(--lightRedText)] font-bold">
            Página {{ currentPage }} de {{ totalPages }}
          </span>

          <!-- Botão de próxima página -->
          <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
            class="px-4 py-2 rounded-lg bg-[var(--lightRed)] text-white disabled:bg-gray-300 disabled:cursor-not-allowed">
            Próxima
          </button>
        </nav>
      </div>

      <!-- Números de página abaixo -->
      <div class="flex justify-center flex-wrap gap-2 mt-4">
        <ng-container *ngFor="let page of totalPagesArray">
          <ng-container *ngIf="page === '...'">
            <span class="px-3 py-1 text-gray-500">...</span>
          </ng-container>

          <ng-container *ngIf="page !== '...'">
            <button [disabled]="page === currentPage" (click)="goToPage(page)" [ngClass]="{
          'bg-[var(--lightRed)] text-white font-bold': page === currentPage,
          'border text-[var(--lightRedText)] hover:bg-[var(--lightRed)] hover:text-white': page !== currentPage
        }" class="px-3 py-1 rounded-md">
              {{ page }}
            </button>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>


    <ng-template #noQuestions>
      <div class="text-center text-[--lightRedText] font-bold mt-10 mb-10" style="margin-top: 10%;
      height: 50vh;">
        <p>Nenhuma questão encontrada.</p>
      </div>
    </ng-template>
  </div>
</main>